import { CartLinesUpdateEvent } from '@shopify/events';
const topButton = document.querySelector('[data-ac-back-top]');
if (topButton) {
  let scheduled = false;
  const paint = () => { topButton.hidden = scrollY < 350; scheduled = false; };
  window.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(paint); } }, {passive:true});
  topButton.addEventListener('click', () => window.scrollTo({top:0, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
  paint();
}
document.addEventListener('submit', async event => {
  const form = event.target.closest('[data-ac-card-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button');
  if (button.disabled) return;
  const error = form.querySelector('[role="alert"]');
  error.hidden = true;
  button.disabled = true;
  button.setAttribute('aria-busy','true');
  button.textContent = 'Adicionando…';
  const deferred = CartLinesUpdateEvent.createPromise();
  const id = form.elements.id.value;
  const quantity = Number(form.elements.quantity.value);
  form.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{id,quantity}],promise:deferred.promise}));
  // Also consume rejection if no cart component is mounted on this template.
  deferred.promise.catch(() => {});
  try {
    const response = await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js', {
      method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:[{id,quantity}],sections:['cart-drawer-section'],sections_url:location.pathname})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Não foi possível adicionar este produto.');
    // Let native cart components render the returned section and refresh totals.
    let cart;
    try {
      const summary = await fetch((window.Shopify?.routes?.root || '/')+'cart.js', {credentials:'same-origin',cache:'no-store'});
      if (summary.ok) cart = await summary.json();
    } catch (_) { /* The add succeeded; never repeat it because a totals read failed. */ }
    const sectionDoc = new DOMParser().parseFromString(data.sections?.['cart-drawer-section'] || '', 'text/html');
    const count = Number(sectionDoc.querySelector('[ref="cartItemCount"]')?.textContent);
    deferred.resolve({
      ...(cart ? {cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart)} : {}),
      detail:{sections:data.sections,itemCount:cart?.item_count ?? count,source:'ac-card-add',didError:false}
    });
    document.dispatchEvent(new CustomEvent('lcdb:cart-updated'));
    document.getElementById('cart-drawer')?.open?.();
    button.textContent = 'Adicionado ✓';
  } catch (failure) {
    deferred.reject(failure);
    error.textContent = failure.message || 'Confira sua conexão e tente novamente.';
    error.hidden = false;
    button.textContent = 'Tentar novamente';
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    setTimeout(() => { if (!button.disabled) button.textContent = 'Adicionar ao carrinho'; },1800);
  }
});
